export const BLUE = '#001831'
export const BLUE_PRINCIPAL = '#001021'
export const BLUE_PRINCIPAL_50 = '#004A99'
export const BLUE_WHITER = '#49C5FD'
export const BLUE_LIGHTER = '#00A5F0'
export const BLUE_PRINCIPAL_90 = '#001831'
export const GREEN = '#45B366'
export const LIGHT_YELLOW = '#FFFEF3'
export const DARK = '#28293D'
export const GREY_DARKEST = '#212121'
export const GREY = '#E1E0E7'
export const GREY_100 = '#F1F0F5'
export const GREY_200 = '#C6C5CE'
export const GREY_300 = '#7A7786'
export const GREY_400 = '#5F5C6B'
export const GREY_500 = '#4E4B59'
export const GREY_600 = '#33303E'
export const GREY_800 = '#343A40'
export const GREY_DARK = '#555555'
export const GREY_LIGHTS = '#C8C8C8'
export const GREY_LIGHTS_2 = '#F8F8F8'
export const GREY_LIGHTEST = '#ECECEC'
export const GREY_MEDIUM = '#777777'
export const WHITE = '#FFF'
export const RED = '#FF6B6B'
